import axios from 'axios';
import { getAccessToken } from '../../../selectors/travelUg/payments';
import { getIdUploadValue } from '../../../selectors/travelUg/travelDetails';
import { setIdDocumentIdValue } from '../../../actions/travelUg/travelDetails';

export const idUploadService = (store, next, action) => {
    (async () => {
        try {
            const resp = await upload(store.getState());

            store.dispatch(setIdDocumentIdValue(resp.data.document));
        } catch (e) {
            console.error(e);
            throw e;
        }
    })();
    return next(action);
};

const idUploadPayload = (state) => {
    const idUpload = getIdUploadValue(state);

    const payload = {
        file: idUpload?.value?.base64File || 'N/A',
        contentType: idUpload?.value?.fileType || 'N/A',
        type: 'image',
        name: idUpload?.value?.fileName,
    };

    return {
        ...payload,
    };
};

const upload = async (state) => {
    const loginData = getAccessToken(state);

    try {
        const url = '/om-api/travel-ug/upload-file';
        return await axios.post(url, idUploadPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
